import CreatableSortableComponent from "../../../ui/create/CreatableSortableComponent";
import {RemovableString} from "./StringMultiSelector";

/**
 * String sortable multiselector component for creation.
 */
export default class StringSortableMultiSelector extends CreatableSortableComponent<RemovableString> {
	elementToText(item: RemovableString) {
		return item.label;
	}

	renderMultiValueRemove(props: { data: RemovableString }) {
		if (props.data.removable) {
			return super.renderMultiValueRemove(props)
		}
		return null;
	};
}